import { Cwb_PositionalAttribute } from "../../../../Shared/Shared.js";
import { ofArray } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export const lemma = new Cwb_PositionalAttribute("lemma", "Lemma");

export const ordkl = new Cwb_PositionalAttribute("ordkl", "Part-of-speech");

export const type = new Cwb_PositionalAttribute("type", "Type");

export const gradDia = new Cwb_PositionalAttribute("grad_dia", "Degree or voice");

export const tidBestemthet = new Cwb_PositionalAttribute("tid_bestemthet", "Tense or definiteness");

export const modusKasus = new Cwb_PositionalAttribute("modus_kasus", "Mood or case");

export const personType2 = new Cwb_PositionalAttribute("person_type2", "Person or type 2");

export const tall = new Cwb_PositionalAttribute("tall", "Number");

export const kjonn = new Cwb_PositionalAttribute("kjonn", "Gender");

export const list = ofArray([lemma, ordkl, type, gradDia, tidBestemthet, modusKasus, personType2, tall, kjonn]);

